import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var ClockGraphicIcon = function ClockGraphicIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.001 0C5.374 0 .002 5.372.002 11.999c0 6.627 5.372 11.999 12 11.999 6.626 0 11.998-5.372 11.998-12C24 5.373 18.628 0 12.001 0zm0 1C18.076 1 23 5.924 23 11.999c0 6.074-4.924 10.999-10.999 10.999-6.074 0-10.999-4.925-10.999-11C1.002 5.925 5.927 1 12.002 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 4.107a.5.5 0 01.492.41l.008.09v5.75a.5.5 0 01-.016.124 1.595 1.595 0 11-1.204 2.942l-.055.066-3.485 3.485-.07.057a.5.5 0 01-.637-.764l3.485-3.485.064-.053a1.596 1.596 0 01.935-2.25.159.159 0 01-.009-.033l-.008-.09v-5.75a.5.5 0 01.5-.5zm0 7.297a.595.595 0 100 1.19.595.595 0 000-1.19z"
  })));
};

ClockGraphicIcon.displayName = "ClockGraphicIcon";
ClockGraphicIcon.defaultProps = {
  size: 48
};
ClockGraphicIcon.displayName = "ClockGraphicIcon";
ClockGraphicIcon.iconName = "Clock";
export default ClockGraphicIcon;